import { AxiosResponse } from "axios";
import api from "../api/base-api";
import analyticsApi from "../api/analytics-api";
import analyticsPgApi from "../api/analytics-api-pg";

const fetchAppInstallsForDeveloperApi = (token: string): Promise<AxiosResponse> => {
    return api.get(`analytics/developer/app-installs`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

const fetchVersionForDeveloperAppApi = (token: string, appId: string): Promise<AxiosResponse> => {
    return api.get(`applications/developer/${appId}/versionings`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

const fetchCountriesForDeveloperAppApi = (token: string, appId: string): Promise<AxiosResponse> => {
    return api.get(`countries/developer/analytics?appId=${appId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

const fetchStartDateForSelectedAppApi = (token: string, appId: string): Promise<AxiosResponse> => {
    return api.get(`applications/developer/${appId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

const fetchCountryDistributionApi = (
    token: string,
    applicationId: string
): Promise<AxiosResponse> => {
    return api.post(
        `applications/developer/country-distribution`,
        {
            applicationId,
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

interface SelectedVersion {
    id: string;
    name: string;
}

interface SelectedCountry {
    id: string;
    name: string;
}

const fetchChartDataApi = (
    appId: string,
    versions: Array<SelectedVersion> | null,
    countries: Array<SelectedCountry> | null,
    dateRange: Array<Date>,
    token: string,
    view?: string | null
): Promise<AxiosResponse> => {
    const GET_CHART_FROM_POSTGRES = true;
    const api = GET_CHART_FROM_POSTGRES ? analyticsPgApi : analyticsApi;
    return api.post(
        `/developer/chart`,
        {
            appId,
            versions: versions ? versions.map((version) => version.id) : null,
            countries: countries ? countries.map((country) => country.name) : null,
            dateRange: dateRange.map(
                (d) => `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`
            ),
            token,
            view,
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

const downloadApplicationAnalyticsDataApi = (
    appId: string,
    versions: Array<SelectedVersion> | null,
    countries: Array<SelectedCountry> | null,
    dateRange: Array<Date>,
    token: string
) => {
    return api.post(
        `/analytics/download-report?appAnalytics=true`,
        {
            appId,
            versions: versions ? versions.map((version) => version.id) : null,
            countries: countries ? countries.map((country) => country.name) : null,
            dateRange: dateRange.map(
                (d) => `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`
            ),
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            responseType: "blob",
        }
    );
};
const downloadOemAnalyticsDataApi = (
    countries: Array<SelectedCountry> | null,
    dateRange: Array<Date> | null,
    token: string
) => {
    return api.post(
        `/analytics/download-report?appAnalytics=false`,
        {
            countries: countries ? countries.map((country) => country.name) : null,
            dateRange: dateRange?.map(
                (d) => `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`
            ),
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            responseType: "blob",
        }
    );
};

export {
    fetchVersionForDeveloperAppApi,
    fetchCountriesForDeveloperAppApi,
    fetchAppInstallsForDeveloperApi,
    fetchStartDateForSelectedAppApi,
    fetchCountryDistributionApi,
    fetchChartDataApi,
    downloadApplicationAnalyticsDataApi,
    downloadOemAnalyticsDataApi,
};
